/*
 * Ryan O'Dowd
 * 2021-03-06
 * © Copyright 2021 Oakwood Software Consulting, Inc.  All Rights Reserved.
 */
import {
  Image,
  Linking,
  TouchableOpacity,
  View,
} from 'react-native';
import React from 'react';
import fb from '@utils/firebase';
import getStyles from './styles';
import hooks from '@hooks';

const DownloadLinks = (_p: DownloadLinksProps) => {
  const props = {
    ...defaultProps,
    ..._p,
  };

  const styles = hooks.useStyles(getStyles);
  const navigation = hooks.useNavigation();

  const _handleClick = (store) => {
    fb.logEvent(fb.analytics, 'Download button clicked', {store});
  };

  return (
    <View style={styles.container}>
      {/* @TODO: convert this to a table with links in headers, column 0 is ios, android, ipad, etc.
      <Text>Wrinkly is available for download from the App Store and Play Store for mobile devices (iPhone and Android), tablets (iPad and Android), desktop (macOS and Chromebooks), and there is a web version available for all of those platforms plus Windows.</Text>
      */}
      <View style={[styles.links, props.isVertical && styles.verticalLinks]}>
        <TouchableOpacity
          style={styles.link}
          onPress={() => {
            _handleClick('app store');
            Linking.openURL('https://apps.apple.com/us/app/wrinkly-bible-memory/id1615885499?ls=1');
          }}
        >
          <Image
            style={styles.linkImage}
            source={require('@assets/img/apple_app_store_icon.png')}
            alt='iOS download'
          />
        </TouchableOpacity>
        <TouchableOpacity
          style={styles.link}
          onPress={() => {
            _handleClick('play store');
            Linking.openURL('https://play.google.com/store/apps/details?id=com.oakwoodsc.wrinkly');
          }}
        >
          <Image
            style={styles.linkImage}
            source={require('@assets/img/google_play_store_icon.png')}
            alt='Android download'
          />
        </TouchableOpacity>
        {!props.hideWeb &&
          <TouchableOpacity
            style={styles.link}
            onPress={() => {
              _handleClick('web');
              navigation.navigate('/app');
            }}
          >
            <Image
              style={styles.linkImage}
              source={require('@assets/img/web_app_icon.png')}
              alt='Web download'
            />
          </TouchableOpacity>
        }
        {/* @TODO: also let users know about desktop macos and chromeos */}
      </View>
    </View>
  );
};

class DownloadLinksProps {
  hideWeb?: boolean;
  isVertical?: boolean;
};
const defaultProps = new DownloadLinksProps();

export default DownloadLinks;
